// Is a given variable undefined?
export default function isUndefined(obj) {
  return obj === void 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isUndefined.js
// module id = 492
// module chunks = 0